module.exports = __webpack_public_path__ + "img/de-wit.f5951a98.jpg";